import React, { lazy, useContext } from "react";
import { useSelector } from "react-redux";

/// React router dom
import { Routes, Route } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
///Dashboard
import Dashboard from "./pages/Dashboard/Dashboard";
import OrderMgtDashboard from "./pages/Dashboard/OrderMgtDashboard";

/// Layout
import Nav from "./layouts/nav/index";
import Footer from "./layouts/Footer";

/// App
///Product
import ProductList from "./pages/Products/ProductList";
import ProductReports from "./pages/Products/ProductReports";

/// Pages
import UserList from "./pages/Users/UserList";
import CategoriesList from "./pages/Master/Categories/CategoriesList";
import SubCategories from "./pages/Master/Categories/SubCategories";
import ChangePassword from "./pages/Settings/ChangePassword";
import AdminPasscodeSettings from "./pages/Settings/AdminPasscodeSettings";

import Attributes from "./pages/Master/Attributes/Attributes";
import Terms from "./pages/Master/Terms/Terms";
import VendorList from "./pages/Users/VendorList";
import ClientList from "./pages/Users/ClientList";
import Warehouse from "./pages/Master/Warehouse/Warehouse";
import CourierType from "./pages/Master/Courier/CourierType";

import CreateProduct from "./pages/Products/CreateProduct";

import OrderList from "./pages/Order/OrderList";
import SkidbarcodeGenerate from "./pages/Order/SkidbarcodeGenerate";

import AddEditOrder from "./pages/Order/AddEditOrder";
import ViewOrder from "./pages/Order/ViewOrder";
import AuditTrailReport from "./pages/Order/AuditTrailReport";

import WeightVerification from "./pages/Order/WeightVerification";
import InventoryHistory from "./pages/Inventory/InventoryHistory";
import BulkInventory from "./pages/Inventory/BulkInventory";
import MRHistoryReport from "./pages/Inventory/MRHistoryReport";
import MRPurchaseOrderReport from "./pages/Inventory/MRPurchaseOrderReport";
import MRDiscrepancyReport from "./pages/Inventory/MRDiscrepancyReport";

import StockManagement from "./pages/Inventory/StockManagement";
import DispatchDetails from "./pages/Order/Dispatchdetails";

import { ThemeContext } from "../context/ThemeContext";

import PrivateRoute from "../_helpers/PrivateRoute";
import ProductStockReport from "./pages/Accountant/ProductStockReport";
import ArchiveProducts from "./pages/Products/ArchiveProducts";
import TransactionProductReport from "./pages/Products/TransactionProductReport";
import ProductExpirationReport from "./pages/Products/ProductExpirationReport";

import SalesProductReport from "./pages/Products/SalesProductReport";

const Privacy = lazy(() => import("./pages/unauthorized/Privacy"));

const Router = () => {
  const permissionData = useSelector((x) => x.auth.permissionList);

  const { menuToggle } = useContext(ThemeContext);

  const routes = [
    /// Apps
    // { url: "app-profile", element: AppProfile },
    ///DashBoard
    { url: "*", element: ChangePassword },
    {
      url: "AdminPasscodeSettings",
      element: AdminPasscodeSettings,
      role: [permissionData.SuperAdmin, permissionData.Admin],
    },
    {
      url: "Dashboard",
      element: Dashboard,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "order-dashboard",
      element: OrderMgtDashboard,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    /// products
    {
      url: "ProductList",
      element: ProductList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "ProductReports",
      element: ProductReports,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "ProductExpirationReport",
      element: ProductExpirationReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },

    /// pages

    {
      url: "UserList",
      element: UserList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "CategoriesList",
      element: CategoriesList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "SubCategories",
      element: SubCategories,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "Attributes",
      element: Attributes,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "Terms",
      element: Terms,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "ChangePassword",
      element: ChangePassword,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.WarehouseManager,
        permissionData.Dispatcher,
        permissionData.WarehouseAssistant,
        permissionData.Accountant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "VendorList",
      element: VendorList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "ClientList",
      element: ClientList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "Warehouse",
      element: Warehouse,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "CourierType",
      element: CourierType,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "CreateProduct",
      element: CreateProduct,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },

    {
      url: "OrderList",
      element: OrderList,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "skidbarcodeGenerate",
      element: SkidbarcodeGenerate,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "AddEditOrder",
      element: AddEditOrder,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "ViewOrder",
      element: ViewOrder,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "AuditTrailReport",
      element: AuditTrailReport,
      role: [permissionData.SuperAdmin, permissionData.Admin],
    },
    {
      url: "OrderPreparation",
      element: WeightVerification,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
      ],
    },
    {
      url: "DispatchDetails",
      element: DispatchDetails,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.Dispatcher,
      ],
    },
    // { url: "InventoryManagement", element: InventoryManagement, role: [permissionData.SuperAdmin, permissionData.Admin, permissionData.Dispatcher] },
    {
      url: "StockManagement",
      element: StockManagement,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "InventoryHistory",
      element: InventoryHistory,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },

    {
      url: "BulkInventory",
      element: BulkInventory,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
      ],
    },
    {
      url: "MRHistoryReport",
      element: MRHistoryReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "MRPurchaseOrderReport",
      element: MRPurchaseOrderReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "MRDiscrepancyReport",
      element: MRDiscrepancyReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.OpsAdmin,
      ],
    },

    //Accountant
    {
      url: "ProductStock",
      element: ProductStockReport,
      role: [permissionData.SuperAdmin, permissionData.Accountant],
    },

    //archive product

    {
      url: "archiveProducts",
      element: ArchiveProducts,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },

    //transaction product report
    {
      url: "TransactionProductReport",
      element: TransactionProductReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "/QB/privacy",
      element: Privacy,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OrderAnalyst,
        permissionData.Dispatcher,
        permissionData.WarehouseManager,
        permissionData.WarehouseAssistant,
        permissionData.Accountant,
        permissionData.OpsAdmin,
      ],
    },
    {
      url: "TransactionReport",
      element: SalesProductReport,
      role: [
        permissionData.SuperAdmin,
        permissionData.Admin,
        permissionData.OpsAdmin,
      ],
    },
  ];

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  let pagePath = path.split("-").includes("page");

  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          >
            <Routes>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  element={
                    <PrivateRoute roles={data.role}>
                      <data.element />
                    </PrivateRoute>
                  }
                />
              ))}
            </Routes>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      {/* <Setting /> */}
    </>
  );
};

export default Router;
